import styled from 'styled-components';

import Heading, { HeadingProps } from '../Heading';

export type H1Props = Omit<HeadingProps, 'tagName'>;

const H1 = styled(Heading).attrs({
  tagName: 'h1',
})``;

H1.displayName = 'H1';

export default H1;
